var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "float-right" },
    [
      _c("router-link", { attrs: { href: "#", to: "dashboard" } }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/csmworkflow/img/logo.svg") }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }